// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  createKeyVault,
  type KeyVaultContext,
  type KeyVaultClientOptionalParams,
} from "./keyVaultContext.js";
export {
  recoverDeletedCertificate,
  purgeDeletedCertificate,
  getDeletedCertificate,
  getDeletedCertificates,
  restoreCertificate,
  backupCertificate,
  mergeCertificate,
  deleteCertificateOperation,
  getCertificateOperation,
  updateCertificateOperation,
  getCertificate,
  updateCertificate,
  updateCertificatePolicy,
  getCertificatePolicy,
  getCertificateVersions,
  importCertificate,
  createCertificate,
  deleteCertificateIssuer,
  getCertificateIssuer,
  updateCertificateIssuer,
  setCertificateIssuer,
  getCertificateIssuers,
  deleteCertificateContacts,
  getCertificateContacts,
  setCertificateContacts,
  deleteCertificate,
  getCertificates,
} from "./operations.js";
export type {
  RecoverDeletedCertificateOptionalParams,
  PurgeDeletedCertificateOptionalParams,
  GetDeletedCertificateOptionalParams,
  GetDeletedCertificatesOptionalParams,
  RestoreCertificateOptionalParams,
  BackupCertificateOptionalParams,
  MergeCertificateOptionalParams,
  DeleteCertificateOperationOptionalParams,
  GetCertificateOperationOptionalParams,
  UpdateCertificateOperationOptionalParams,
  GetCertificateOptionalParams,
  UpdateCertificateOptionalParams,
  UpdateCertificatePolicyOptionalParams,
  GetCertificatePolicyOptionalParams,
  GetCertificateVersionsOptionalParams,
  ImportCertificateOptionalParams,
  CreateCertificateOptionalParams,
  DeleteCertificateIssuerOptionalParams,
  GetCertificateIssuerOptionalParams,
  UpdateCertificateIssuerOptionalParams,
  SetCertificateIssuerOptionalParams,
  GetCertificateIssuersOptionalParams,
  DeleteCertificateContactsOptionalParams,
  GetCertificateContactsOptionalParams,
  SetCertificateContactsOptionalParams,
  DeleteCertificateOptionalParams,
  GetCertificatesOptionalParams,
} from "./options.js";
